import { initialIntegrationsState, INTEGRATIONS_ACTIONS } from './integrations.types'

/**
 *
 * @param {import('./integrations.types').IntegrationsSlice} state
 * @param {import('./integrations.types').IntegrationsAction} action
 * @returns
 */
export function integrationsReducer(state = initialIntegrationsState, { type, payload }) {
  switch (type) {
    case INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_STATUS:
      return { ...state, status: payload }

    case INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case INTEGRATIONS_ACTIONS.SET_INTEGRATIONS_DATA:
      return { ...state, data: payload }

    case INTEGRATIONS_ACTIONS.CLEAR_INTEGRATIONS_ERRORS:
      return { ...state, errors: [] }

    case INTEGRATIONS_ACTIONS.CLEAR_INTEGRATIONS_DATA:
      return { ...state, data: null }

    default:
      return state
  }
}
